<template>
	<div id="contact-page" data-aos="fade">
		<!-- Hero -->
		<section class="top-section">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-10 col-xl-8 mx-auto">
						<p class="hero-eyebrow" data-aos="fade-up">Contacto</p>
						<h1 class="hero-title" data-aos="fade-up" data-aos-delay="50">Estamos aquí para ayudarte</h1>
						<p class="hero-lead" data-aos="fade-up" data-aos-delay="150">
							Cuéntanos tu situación y nos pondremos en contacto contigo a la brevedad posible.
						</p>
					</div>
				</div>
			</div>
		</section>

		<!-- Contenido -->
		<section class="content-section">
			<div class="container">
				<!-- Categorías -->
				<div class="row mb-5 category-row">
					<div class="col-md-4 mb-3 mb-md-0" data-aos="fade-up" data-aos-delay="50">
						<button
							type="button"
							class="category-card"
							:class="{ active: selectedCategory === 'queja' }"
							@click="selectedCategory = 'queja'"
						>
							<div class="category-icon category-icon--navy">
								<i class="fa-regular fa-circle-exclamation"></i>
							</div>
							<h3 class="category-title">Queja</h3>
							<p class="category-text">
								Reporta un problema o inconformidad con nuestro servicio
							</p>
						</button>
					</div>

					<div class="col-md-4 mb-3 mb-md-0" data-aos="fade-up" data-aos-delay="150">
						<button
							type="button"
							class="category-card"
							:class="{ 'active-primary': selectedCategory === 'afiliarme' }"
							@click="selectedCategory = 'afiliarme'"
						>
							<div class="category-icon category-icon--primary">
								<i class="fa-regular fa-user-plus"></i>
							</div>
							<h3 class="category-title">Afiliarme</h3>
							<p class="category-text">
								Únete a nuestra red de profesionales legales
							</p>
						</button>
					</div>

					<div class="col-md-4" data-aos="fade-up" data-aos-delay="250">
						<router-link to="/faqs" class="category-card category-card--faq">
							<div class="category-icon category-icon--blue">
								<i class="fa-regular fa-messages"></i>
							</div>
							<h3 class="category-title">FAQ's</h3>
							<p class="category-text">
								Consulta las preguntas frecuentes sobre unlawk
							</p>
						</router-link>
					</div>
				</div>

				<div class="row">
					<!-- Información de contacto -->
					<div class="col-md-6 mb-5 mb-md-0">
						<h2 class="info-heading" data-aos="fade-right">Información de contacto</h2>

						<div class="info-list">
							<div class="info-item" data-aos="fade-right" data-aos-delay="50">
								<div class="info-icon">
									<i class="fa-regular fa-envelope"></i>
								</div>
								<div>
									<h3 class="info-label">Email</h3>
									<p class="info-value">contacto@unlawk.com</p>
								</div>
							</div>

							<div class="info-item" data-aos="fade-right" data-aos-delay="100">
								<div class="info-icon">
									<i class="fa-regular fa-phone"></i>
								</div>
								<div>
									<h3 class="info-label">Teléfono</h3>
									<p class="info-value">+52 55 1234 5678</p>
								</div>
							</div>

							<div class="info-item" data-aos="fade-right" data-aos-delay="150">
								<div class="info-icon">
									<i class="fa-regular fa-location-dot"></i>
								</div>
								<div>
									<h3 class="info-label">Ubicación</h3>
									<p class="info-value">Ciudad de México, México</p>
								</div>
							</div>
						</div>
					</div>

					<!-- Formulario -->
					<div class="col-md-6">
						<div v-if="selectedCategory" class="category-badge mb-3">
							<p class="mb-0">
								Categoría seleccionada:
								<strong>{{ categoryLabel }}</strong>
							</p>
						</div>

						<b-form @submit.prevent="handleSubmit">
							<b-form-group label="Nombre" label-for="nombre" data-aos="fade-up">
								<b-form-input
									id="nombre"
									v-model="formData.nombre"
									type="text"
									required
								></b-form-input>
							</b-form-group>

							<b-form-group label="Email" label-for="email" data-aos="fade-up" data-aos-delay="50">
								<b-form-input
									id="email"
									v-model="formData.email"
									type="email"
									required
								></b-form-input>
							</b-form-group>

							<b-form-group label="Teléfono" label-for="telefono" data-aos="fade-up" data-aos-delay="100">
								<b-form-input
									id="telefono"
									v-model="formData.telefono"
									type="tel"
								></b-form-input>
							</b-form-group>

							<b-form-group label="Mensaje" label-for="mensaje" data-aos="fade-up" data-aos-delay="100">
								<b-form-textarea
									id="mensaje"
									v-model="formData.mensaje"
									rows="5"
									no-resize
									required
								></b-form-textarea>
							</b-form-group>

							<b-button type="submit" variant="danger" block size="lg" class="btn-submit" data-aos="fade-up">
								<i class="fa-regular fa-paper-plane mr-2"></i>
								Enviar mensaje
							</b-button>
						</b-form>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			selectedCategory: null,
			formData: {
				nombre: '',
				email: '',
				telefono: '',
				mensaje: '',
			},
		}
	},

	computed: {
		categoryLabel() {
			if (this.selectedCategory === 'afiliarme') {
				return 'Afiliación'
			}
			return this.selectedCategory
		},
	},

	methods: {
		handleSubmit() {
			console.log('Form submitted:', {
				...this.formData,
				categoria: this.selectedCategory,
			})
			alert('Gracias por contactarnos. Te responderemos pronto.')
			this.formData = {
				nombre: '',
				email: '',
				telefono: '',
				mensaje: '',
			}
		},
	},
}
</script>
